const user = {
  not_found: 2003,
  duplicate: 2004,
  update: 2005,
  passwordless_token_invalid: 2006,
  unauthorized: 2007,
  lacks_first_last_name: 2008,
};
export default user;
